module.exports = __webpack_public_path__ + "static/img/xukezheng.0079ab8e.png";